
<p class= "lead">detailed Data:</p>

Set -- mistakeType-- count
<div  *ngFor="let m of (mts$ | async)?.result">
  {{m|json}}
</div>
